module.exports = __webpack_public_path__ + "media/images/icons/ellipses-93181d02bdc40baa8a78d2604a4ce061.svg";